// @flow
export { default } from './Tooltip';
export type { Position } from './Tooltip';
